import { cn } from '@/lib/utils';

/**
 * Logo de Prixia que sigue el tema de la app.
 *
 * Un <img> con SVG no ve la clase `dark` del documento, así que se cargan las
 * dos versiones y Tailwind muestra la que corresponde: la de fondo claro y la
 * de fondo oscuro (`prixia-logo-white.svg`, con los tonos más claros).
 * Las pantallas que siempre son claras pueden seguir usando el <img> directo.
 */
export function LogoPrixia({ className }: { className?: string }) {
  return (
    <>
      <img src="/prixia-logo.svg" alt="Prixia" className={cn('dark:hidden', className)} />
      <img
        src="/prixia-logo-white.svg"
        alt="Prixia"
        className={cn('hidden dark:block', className)}
      />
    </>
  );
}
